export default __webpack_public_path__ + "static/media/itweekend.09b57893.png";